<template>
   <table class="tandaentries">
       <draggable v-model="tanda.entries" group="entries" @start="drag=true" @end="update" tag="tbody"
                  :item-key="(e) => e.id != null ? e.id : tanda.entries.indexOf(e)">
            <template #item="{ element: entry }">
                <tr class="tandaentry">
                    <td>{{ entry.order }}</td>
                    <td class="orchestra">{{ entry.instance.recording.orchestra.name }}</td>
                    <td class="singers">
                        <span v-for="(singer, s_index) in entry.instance.recording.singers"><span v-if="s_index > 0">, </span>{{ singer.name }}</span>
                    </td>
                    <td class="title">
                        <a :href="entry.instance.file.play_url" onclick="return false;" @click="playFile(entry.instance.file.play_url)" class="playable">{{ entry.instance.recording.song.title }}</a>
                        <span v-if="entry.instance.recording.subtitle" class="subtitle"> ({{ entry.instance.recording.subtitle }})</span>
                        <span :class="'badge badge-lp-' + entry.instance.file.source.name ">{{ entry.instance.file.source.name }}</span>
                        <span class="badge bg-info" v-for="tag in entry.instance.tags">{{ tag }}</span>
                    </td>
                    <td class="year">
                        {{ entry.instance.recording.year }}
                    </td>
                    <td class="genre">
                        {{ entry.instance.recording.genre.name }}
                    </td>
                    <td>{{ entry.instance.length_hr }}</td>
                    <td><bpm-value :instance="entry.instance"></bpm-value></td>
                    <td v-if="removeHook"><a class="clickable red"  @click="remove(entry.instance.recording, entry.instance)"><octicon name="trashcan"></octicon></a></td>
                </tr>
            </template>
            <template #footer>
                <tr>
                    <td colspan="7"></td>
                    <td class="total">{{ tanda.length_hr }}</td>
                    <td></td>
                </tr>
            </template>
       </draggable>
    </table>
</template>
<script>

    import { tdj2} from "@/tdj2";
    import draggable from 'vuedraggable'

    import { bus } from '@/modules/bus'
    export default {
        name: "Tanda",

        components: {
            draggable,
        },

        props: {
            tanda: {
                type: Object,
                default: function () {
                    return {
                        entries: [],
                        tags: [],
                        singers: []
                    }
                }
            },
            updateHook: null,
            removeHook: null
        },

        data() {
            return {
                state: tdj2.state,
                playlist: [],
                playlist_version: 0,
                // Vue 2 exposed a component instance id as this._uid; Vue 3
                // removed it, so we mint our own to keep playlist ids unique
                // per mounted instance.
                playlist_uid: Math.random().toString(36).slice(2),
                drag: false
            }
        },

        created() {
            this.updatePlayList()
            bus.on('lpCurrentTandaChanged', this.updatePlayList)
        },

        methods: {
            updatePlayList() {
                this.playlist_version++
                this.playlist = []
                for (let te of this.tanda.entries) {
                    this.playlist.push([te.instance.file.play_url, te.instance.file.play_title, te.instance.renders, te.id, te.instance.id])
                }
            },
            playFile(url) {
                this.checkPlaylist()
                tdj2.playFile(url, this.$root)
            },
            checkPlaylist() {
                let pls_id = 'tanda_' + this.playlist_uid + '_' + this.playlist_version
                if (tdj2.state.current_playlist_id !== pls_id) {
                    tdj2.state.current_playlist_id = pls_id
                    tdj2.newPlaylist(this.playlist)
                }
            },
            update() {
                if (this.updateHook) {
                    this.updateHook()
                }
            },
            remove(r, i) {
                if (this.removeHook) {
                    if (confirm('Удалить композицию из танды?')) {
                        this.removeHook(r, i)
                    }
                }
            }

        }
    }

</script>
<style lang="less">


    .tandaentries {
        margin-bottom: 30px;

        td.total {
            padding-left: 8px;
            padding-top: 5px;
            padding-bottom: 5px;
            padding-right: 8px;
        }

        .tandaentry {
            td {
                padding-left: 8px;
                padding-top: 5px;
                padding-bottom: 5px;
                padding-right: 8px;
                border-top: 1px solid #eeeeee;
                background-color: #f5f5f5;
            }

            .badge {
                margin-left: 5px;
                font-size: 8.5pt;
                padding-top: 3px;
                padding-left: 5px;
                padding-right: 5px;
                padding-bottom: 3px;
                display: inline-block;
                vertical-align: top;
                margin-top: 3px;
            }

             .octicon {
                display: inline-block;
                vertical-align: top;
                margin-top: 3px;
            }

        }
    }

</style>